import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppRoutes, AppRoutesCombined } from '@sparrow-card/sparrow-card-constants';
import Footer from 'components/Footer';
import Header from 'components/Header';
import SkipLinks from 'components/SkipLinks/SkipLinks';
import { ContentBlockIds } from 'enums/ContentBlockIds';
import { useNavigateWithPreservedParams } from 'hooks/useNavigateWithPreservedParams';
import { usePageTitle } from 'hooks/usePageTitle';
import styles from './SparrowMainLayout.module.scss';

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigateWithPreservedParams();
  const navigateRef = useRef(navigate);

  navigateRef.current = navigate;

  usePageTitle();

  useEffect(() => {
    if (location.pathname === '/') {
      navigateRef.current(AppRoutes.Apply);
    }
  }, [location.pathname]);

  const isCenteredLogo = !(
    location.pathname === AppRoutes.Apply ||
    location.pathname === '/demo/apply' ||
    location.pathname === AppRoutes.PreApproved ||
    location.pathname === AppRoutesCombined.ReinstatementApply ||
    location.pathname === AppRoutesCombined.ReinstatementPreApproved ||
    location.pathname === AppRoutesCombined.StarlingApply ||
    location.pathname === AppRoutesCombined.StarlingPreApproved
  );

  return (
    <div className={styles.appContainer}>
      <SkipLinks />
      <Header centeredLogo={isCenteredLogo} />
      <main className={styles.outlet} id={ContentBlockIds.MainContent} aria-label="Main Content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
